export default {
  getScriptDomain() {
    const scriptSrc = document.querySelector('script[src$="rapidoc-min.js"]').getAttribute('src');
    if (!scriptSrc.startsWith('http')) {
      return window.location.origin;
    }
    const url = new URL(scriptSrc);
    return url.origin;
  },
};
